import request from "@/utils/request";
// 营销活动管理列表
export function marketingActivitiesApi(data) {
  return request({
    url: "/api/campaignmain/list",
    method: "post",
    data: data,
  });
}
// 营销活动管理列表-查看
export function marketingActLookApi(data) {
  return request({
    url: "/api/campaignmain/view",
    method: "get",
    params: data,
  });
}
// 营销活动管理列表-查看-短信发送列表
export function tCampaignrecordList(data) {
  return request({
    url: "/api/tCampaignrecord/list",
    method: "get",
    params: data,
  });
}
// 营销活动管理列表-查看-短信发送列表
export function tCampaignrecordExport(data) {
  return request({
    url: "/api/tCampaignrecord/export",
    method: "post",
    params: data,
  });
}
// 营销活动管理---新增
export function marketingInsertApi(data) {
  return request({
    url: "/api/campaignmain/insert",
    method: "post",
    data: require("qs").stringify(data),
  });
}
// 营销活动管理---修改
export function marketingEitApi(data) {
  return request({
    url: "/api/campaignmain/edit",
    method: "post",
    data: require("qs").stringify(data),
  });
}
export function marketingDeleteApi(data) {
  // 删除
  return request({
    url: "/api/campaignmain/delete",
    method: "post",
    data: require("qs").stringify(data),
  });
}
// 审核
export function checkEnableApi(data) {
  return request({
    url: "/api/campaignmain/enable",
    method: "post",
    data: require("qs").stringify(data),
  });
}
// 禁用
export function checkDisableApi(data) {
  return request({
    url: "/api/campaignmain/disable",
    method: "get",
    params: data,
  });
}
// ------------条件分组、手工分组---------------------------
export function groundPageApi(data) {
  // 列表--手工、条件公用
  return request({
    url: "/api/cust/grplist/page",
    method: "post",
    data: data,
  });
}

export function groundPageApi1(data) {
  // 列表--手工、条件公用
  return request({
    url: "/api/cust/grplist/page",
    method: "post",
    params: data,
  });
}
export function lookGroundApi(data) {
  // 查看组信息---手工、条件
  return request({
    url: "/api/cust/grplist/query",
    method: "post",
    data: require("qs").stringify(data),
    // require("qs").stringify(cList)
  });
}
// -------手工
export function enableApi(data) {
  // 启用--手工、条件公用
  return request({
    url: "/api/cust/grplist/enable",
    method: "post",
    data: data,
  });
}
export function disableApi(data) {
  // 禁用--手工、条件公用
  return request({
    url: "/api/cust/grplist/disable",
    method: "post",
    params: data,
  });
}
export function deleteApi(data) {
  // 删除--手工、条件公用
  return request({
    url: "/api/cust/grplist/delete",
    method: "post",
    params: data,
  });
}
export function insertApi(queryInfo, data) {
  // 创建--手工、条件公用
  return request({
    url: "/api/cust/grplist/insert",
    method: "post",
    params: queryInfo,
    data: data,
  });
}
export function updateApi(updateInfo, data) {
  // 修改---手工、条件公用
  return request({
    url: "/api/cust/grplist/update",
    method: "post",
    params: updateInfo,
    data: data,
  });
}
// 批量导入会员
export function importGroundApi(params, data) {
  return request({
    url: "/api/cust/grplist/importCustGrp",
    method: "post",
    params: params,
    data: data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
// 手工分组会员导出
export function exportCastApi(data) {
  return request({
    url: "/api/cust/grplist/exportCust",
    method: "post",
    params: data,
  });
}
export function exportConditionApi(data) {
  // 条件分组会员导出
  return request({
    url: "/grplist/exportCustByCondi",
    method: "post",
    params: data,
  });
}
// 清除会员导入
export function clearImportApi(data) {
  return request({
    url: "/api/cust/grplist/clearCust",
    method: "post",
    params: data,
  });
}
// 会员列表
export function queryGrpListApi(data) {
  return request({
    url: "/api/cust/grplist/queryCustGrpList",
    method: "post",
    params: data,
  });
}
// 添加会员
export function insertCustGrpApi(data) {
  return request({
    url: "/api/cust/grplist/insertCustGrp",
    method: "post",
    data: data,
  });
}
// 选择门店
export function shopQueryRegionApi(data) {
  return request({
    url: "/api/shop/queryRegion",
    method: "post",
    params: data,
  });
}
// 选择券库
export function couponsGroupApi(data) {
  return request({
    url: "api/coupons/couponsGroup/list",
    method: "POST",
    params: data,
  });
}
// 选择券包
export function couppacketJuanApi(data) {
  return request({
    url: "/api/coupons/couppacket/list",
    method: "post",
    params: data,
  });
}
// 选择人员
export function custselectCustList(data) {
  return request({
    url: "/api/cust/selectCustList",
    method: "post",
    params: data,
  });
}
